import { render } from "./BlobButton.vue?vue&type=template&id=e66d7118&scoped=true"
import script from "./BlobButton.vue?vue&type=script&lang=js"
export * from "./BlobButton.vue?vue&type=script&lang=js"

import "./BlobButton.vue?vue&type=style&index=0&id=e66d7118&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e66d7118"]])

export default __exports__